import script from "./OrderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderModal.vue?vue&type=script&setup=true&lang=ts"

import "./OrderModal.vue?vue&type=style&index=0&id=c7d90910&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7d90910"]])

export default __exports__